import { get, post, remove, patch } from 'api.vanilla.service';
import { formatErrorMessage } from 'api/helpers';
import { set as setFeedback } from 'feedback.vanilla.service.js';

import phrases from './rawIngredients.phrases';

/**
 * @function fetchRawIngredients
 * @description Fetch all raw ingredient categories
 * @param {object} state
 */
export function fetchRawIngredients(state, filter) {
	filter = state.filter ? `${state.filter};${filter}` : filter;

	// Set params and filter
	const params = {
		limit: state.limit,
		sort: state.sort,
		offset: state.offset,
		filter
	};

	return get('/inventory/raw_ingredients', params, null, state.headers)
		.then(res => {
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
		});
}

/**
 * @function addRawIngredients
 * @description adds raw ingredient categories
 */
export function addRawIngredients(data) {
	return post('/inventory/raw_ingredients', data)
		.then(res => {
			setFeedback(phrases.RAW_INGREDIENTS_ADDED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}

/**
 * @function editRawIngredient
 * @description edits raw ingredient categories
 */
export function editRawIngredient(data) {
	return post(`/inventory/raw_ingredients/${data.id}`, data)
		.then(res => {
			setFeedback(phrases.RAW_INGREDIENT_EDITED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			return Promise.reject;
		});
}

/**
 * @function editRawIngredients
 * @description edits raw ingredient categories
 */
export function editRawIngredients(data) {
	return patch('/inventory/raw_ingredients', data)
		.then(res => {
			setFeedback(phrases.RAW_INGREDIENTS_EDITED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			return Promise.reject;
		});
}

/**
 * @function deleteRawIngredients
 * @description deletes raw ingredient categories
 */
export function deleteRawIngredients(id) {
	return remove(`/inventory/raw_ingredients/${id}`)
		.then(res => {
			setFeedback(phrases.RAW_INGREDIENTS_DELETED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}
